import apiClient from '../../api/client';
import type { PlatformMessage } from './types';

export async function fetchPlatformMessages(): Promise<PlatformMessage[]> {
  const { data } = await apiClient.get<{ messages: PlatformMessage[] }>('/messages');
  return data.messages;
}
